import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { initSmoothScroll } from './modules/smoothScroll';

import { dragscroll } from './modules/dragscroll';
dragscroll();

import { accordion } from './modules/accordion';

import { fvScrollAnimation } from './modules/home/fvScrollAnimation';
import { fvAutoScroll } from './modules/home/fvAutoScroll';

gsap.registerPlugin(ScrollTrigger);


/*
 * ブラウザによるスクロール位置復元を無効化
 */
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

/*
 * 初期スクロール位置をトップにする
 */
window.scrollTo(0, 0);


const lenis = initSmoothScroll();
window.lenis = lenis;


/*
 * リロード・BFCache復帰時にも
 * スクロール位置をトップにする
 */
window.addEventListener('pageshow', () => {
  window.scrollTo(0, 0);

  if (window.lenis) {
    window.lenis.scrollTo(0, {
      immediate: true,
    });
  }
});


window.addEventListener("load", () => {
  accordion();

  /*
   * 念のためロード完了時にも
   * ページトップへ
   */
  window.scrollTo(0, 0);

  if (window.lenis) {
    window.lenis.scrollTo(0, {
      immediate: true,
    });
  }


  const loading = document.querySelector('.p-loading');
  const loadingLogo = document.querySelector('.p-loading_logo');

  if (!loading) return;


  // ローディング中はスクロール禁止
  document.body.classList.add('is-loading');


  // ① ロゴ表示
  requestAnimationFrame(() => {
    loadingLogo?.classList.add('is-show');
  });


  // ② ロゴを少し表示
  setTimeout(() => {

    // ③ ローディング背景を閉じる
    loading.classList.add('is-hide');


    // ④ アニメーション完了後
    setTimeout(() => {

      document.body.classList.remove('is-loading');

      loading.style.display = 'none';

      document
        .querySelector('.p-fv')
        ?.classList.add('action');

    }, 800);

  }, 1200);


  fvScrollAnimation();
  fvAutoScroll();
});